import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useLanguage } from '../../hooks/useLanguage';
import { mapVacancyTo } from '../../utils/navigation';

import { I18nNavigateProps } from './I18nNavigate.types';

export const I18nNavigate: FC<I18nNavigateProps> = ({ to, ...otherProps }) => {
  const { language } = useLanguage();
  const mappedTo = mapVacancyTo(to, language);

  return <Navigate {...otherProps} to={mappedTo} />;
};
